var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakaoCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1265 1226 c-56 -18 -122 -52 -177 -93 -40 -29 -48 -31 -55 -18 -8 13 -27 15 -114 13 l-104 -3 -3 -37 c-3 -36 -5 -38 -38 -38 -32 0 -34 -2 -34 -35 0 -34 -1 -35 -40 -35 -39 0 -40 1 -40 34 0 33 -2 35 -38 38 -35 3 -37 5 -40 41 l-3 38 -107 -3 -107 -3 -3 -37 c-3 -36 -5 -38 -38 -38 -32 0 -34 -2 -34 -35 0 -34 -1 -35 -40 -35 l-40 0 0 -140 0 -140 40 0 c39 0 40 -1 40 -34 0 -33 2 -35 37 -38 35 -3 38 -6 41 -35 3 -30 6 -33 38 -33 29 0 34 -3 34 -24 0 -19 -22 -43 -85 -98 -142 -122 -217 -148 -167 -59 12 21 22 50 22 64 0 29 -33 57 -66 57 -34 0 -82 -47 -96 -92 -16 -54 8 -99 69 -129 40 -19 50 -20 100 -10 66 13 143 54 230 122 69 54 73 56 73 34 0 -11 11 -15 40 -15 39 0 40 -1 40 -34 0 -28 4 -35 23 -38 18 -2 23 -10 25 -41 l3 -38 47 3 c46 3 47 3 50 41 3 32 7 37 28 37 21 0 24 5 24 35 0 34 1 35 40 35 39 0 40 1 40 34 0 33 2 35 38 38 35 3 37 5 40 41 3 35 5 37 37 37 31 0 34 3 37 33 3 29 6 32 41 35 35 3 37 5 37 38 0 33 1 34 40 34 l40 0 0 140 0 140 -40 0 c-35 0 -40 3 -40 24 0 26 53 80 130 132 88 60 111 52 70 -23 -24 -45 -25 -62 -4 -91 40 -58 154 15 154 98 0 79 -104 136 -195 106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakaoCurrencyIcon);
export default __webpack_public_path__ + "static/media/makaoCurrencyIcon.cb717bc5bb0cf54a84a435cb2683f242.svg";
export { ForwardRef as ReactComponent };